import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerContext } from '@src/contexts';
import { useContext, useEffect } from 'react';
import styles from './FullPageWrapper.module.scss';
export const FullPageWrapper = ({ children }) => {
    const { setShowHeader, setShowFooter, setShowUtilityNav, setIsFullscreen } = useContext(ContainerContext);
    useEffect(() => {
        setShowHeader(false);
        setShowFooter(true);
        setShowUtilityNav(false);
        setIsFullscreen(true);
        return () => {
            setShowHeader(true);
            setShowFooter(true);
            setShowUtilityNav(true);
            setIsFullscreen(false);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return _jsx("div", { className: styles.fullPageWrapper, children: children });
};
